export default [
  {value: '1', label: '认证方式'},
  {value: '2', label: '设备秘钥'}
]
